module.exports = __webpack_public_path__ + "img/public/SiteIcons/star.svg?d59a9f15";